import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["name", "select", "accent"]
  static values = { themes: Object }

  connect() {
    this.applyTheme()
  }

  preview() {
    this.applyTheme()
  }

  applyTheme() {
    const theme = this.themesValue[this.selectTarget.value]
    if (!theme) return

    this.setBodyVariable("--club-bg", theme.background)
    this.setBodyVariable("--club-surface", theme.surface)
    const customAccent = this.hasAccentTarget ? this.accentTarget.value.trim() : ""
    this.setBodyVariable("--club-accent", /^#[0-9a-f]{6}$/i.test(customAccent) ? customAccent : theme.accent)
    this.setBodyVariable("--club-accent-alt", theme.accent_alt)
    this.setBodyVariable("--club-text", theme.text)

    if (this.hasNameTarget) {
      this.nameTarget.textContent = this.selectTarget.selectedOptions[0]?.text || this.selectTarget.value
    }
  }

  setBodyVariable(name, value) {
    document.body.style.setProperty(name, value)
  }
}
